import {
  createReducer,
  createRequestReducer
} from 'utils';

import { PRECACHE_DATA } from './constants';
import { GET_STATIC_PAGE_CONTENT } from '../StaticPages/constants';

// const item = {
//   path: PropTypes.string,
//   type: PropTypes.string,
//   loaded: PropTypes.bool
// };

const initialState = {
  items: [],
  loading: false
};

function isDataLoading(items) {
  return items.findIndex(item => item.status === 'SEND') !== -1;
}

export default createReducer(initialState, {
  [PRECACHE_DATA]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) => {
      const oldItems = state.items.filter(item =>
        action.data.indexOf(item.path) === -1);

      const newItems = action.data.map(path =>
        ({ path, type: action.mediaType, status: 'SEND' }));

      const items = oldItems.concat(newItems);
      const loading = isDataLoading(items);

      return Object.assign({}, state, { items, loading });
    },

    SUCCESS: (state, action) => {
      const oldItems = state.items.filter(item =>
        action.data.indexOf(item.path) === -1);

      const newItems = action.data.map(path =>
        ({ path, type: action.mediaType, status: 'SUCCESS' }));

      const items = oldItems.concat(newItems);
      const loading = isDataLoading(items);

      return Object.assign({}, state, { items, loading });
    }
  }),

  [GET_STATIC_PAGE_CONTENT]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) => {
      const items = state.items.filter(({ path }) => path !== action.name);

      items.push({
        path: action.name,
        type: 'page',
        status: 'SEND'
      });

      const loading = isDataLoading(items);

      return Object.assign({}, state, { items, loading });
    },

    SUCCESS: (state, action) => {
      const items = state.items.filter(({ path }) => path !== action.name);

      items.push({
        path: action.name,
        type: 'page',
        loaded: 'SUCCESS'
      });

      const loading = isDataLoading(items);

      return Object.assign({}, state, { items, loading });
    },

    FAIL: (state, action) => {
      const items = state.items.filter(({ path }) => path !== action.name);

      items.push({
        path: action.name,
        type: 'page',
        loaded: 'FAIL'
      });

      const loading = isDataLoading(items);

      return Object.assign({}, state, { items, loading });
    }
  })
});



// WEBPACK FOOTER //
// ./src/redux/Precache/reducer.js